export default __webpack_public_path__ + "static/media/ferdinand-stohr_02.0b60d1ec.jpg";